import { Box, CircularProgress } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { StyledGoogleMaps } from "../../../styled/googleMaps";

const frameSrc = (route) => `${CONFIG.path || ""}${route}`;

const GoogleMapFrameHost = ({
  apiKey,
  payload,
  route,
  title = "Mapa",
  onMessage,
}) => {
  const iframeRef = useRef(null);
  const readyRef = useRef(false);
  const payloadRef = useRef(payload);
  const onMessageRef = useRef(onMessage);
  const [mapReady, setMapReady] = useState(false);
  payloadRef.current = payload;
  onMessageRef.current = onMessage;

  useEffect(() => {
    readyRef.current = false;
    setMapReady(false);
  }, [apiKey]);

  useEffect(() => {
    const onFrameMessage = (event) => {
      if (event.origin !== window.location.origin) return;
      if (event.source !== iframeRef.current?.contentWindow) return;
      if (event.data?.type === "ready") {
        readyRef.current = true;
        event.source.postMessage(
          { type: "init", apiKey, ...payloadRef.current },
          window.location.origin,
        );
        return;
      }
      if (event.data?.type === "mapReady") {
        setMapReady(true);
        return;
      }
      if (event.data?.type === "mapLoading") {
        setMapReady(false);
        return;
      }
      onMessageRef.current?.(event.data);
    };
    window.addEventListener("message", onFrameMessage);
    return () => window.removeEventListener("message", onFrameMessage);
  }, [apiKey]);

  useEffect(() => {
    if (!readyRef.current) return;
    iframeRef.current?.contentWindow?.postMessage(
      { type: "update", ...payload },
      window.location.origin,
    );
  }, [payload]);

  return (
    <StyledGoogleMaps.MapContainer sx={{ position: "relative" }}>
      <Box
        component="iframe"
        key={apiKey}
        ref={iframeRef}
        src={frameSrc(route)}
        title={title}
        sx={{ border: 0, display: "block", width: "100%", height: "100%" }}
      />
      {!mapReady && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            zIndex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: "background.paper",
          }}>
          <CircularProgress />
        </Box>
      )}
    </StyledGoogleMaps.MapContainer>
  );
};

export default GoogleMapFrameHost;
